// extracted by mini-css-extract-plugin
module.exports = {"headline":"az_vfb","circularPage":"az_wfb"};